import React, { useEffect, useState } from "react";
import Heading from "../Component/Heading";
import { useForm, Controller } from "react-hook-form";
import NavText from "../Component/NavText";
import { json, useNavigate } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  FormPageAction,
  FormPageContactAction,
  TransactionAction,
  UseridAction,
  couponDetailAction,
  restCouponDetailAction,
  rewardsDataAction,
} from "../Component/Redux/Feature/UrlSlice";
import Popup from "../Component/Popup";
import Popup2 from "../Component/Popup2";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import { apiUrl, calculateUsableReward, typeId } from "../Utils/constants";
import {
  emailAction,
  gstnAction,
  gstnameAction,
  tokenAction,
} from "../Component/Redux/Feature/EmailSlice";
import moment from "moment";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getContentData } from "../Utils/content";
const StartContentNew = ({ appname }) => {
  const [showExtraFields, setShowExtraFields] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [emailParamsExists, setEmailFromParams] = useState(false);
  const [order, setOrder] = useState(0);

  const [paraText, setParaText] = useState("");

  const [showPopup, setShowPopup] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [recommendedDate, setRecommendedDate] = useState(null);

  const [showPopupRenewal, setShowPopupRenewal] = useState(false);

  const [myDateState, setMyDatastate] = useState();

  // -----loading spinne state----
  const [loading, setLoading] = useState(false);
  const [apiStatus, setApiStatus] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);

  const [errorMessagePopup, setErrorMessagePopup] = useState(null);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };
  const togglePopup2 = () => {
    setShowPopup2(!showPopup2);
  };
  const togglePopupRenewal = () => {
    setShowPopupRenewal(!showPopupRenewal);
  };

  const navigate = useNavigate();
  const storeSel = useSelector((state) => state);
  const DataStore = storeSel.UrlData.userDetails;

  const planNameredux = storeSel.UrlData.planName;
  const nameRedux = storeSel.UrlData.userDetails.name;

  const selectedCategory = storeSel.Categories.selectedCategory;
  const selectedBranch = storeSel.Categories.selectedBranch;

  const rewardObjectRedux = storeSel.UrlData.rewardsDetails;

  const [emailValue, setEmailValue] = useState("");

  const [emailNew, setEmailNew] = useState("");

  const [selectedDateEnable, setSelectedDateEnable] = useState(false);

  const emailParam = storeSel.emailData?.emailStored;
  const contactParam = storeSel.emailData?.contactStored;
  const appParam = storeSel.emailData?.appStatus;

  const startDateRedux = storeSel.UrlData?.userDetails.startdate;

  useEffect(() => {
    if (startDateRedux !== null) {
      setSelectedDateEnable(true);
    }
  });

  useEffect(() => {
    if (!emailParamsExists) {
      setEmailFromParams(emailParam);
    }
  }, [emailParamsExists]);

  const startDateConitionsCheck =
    startDateRedux < recommendedDate ? recommendedDate : startDateRedux;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();

  //Phonenumber -input -----------

  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [valid, setValid] = useState(true);

  const handleChangeNumber = (value, country) => {
    clearErrors()
    setPhoneNumber(value);
    setCountryCode(country?.dialCode || "");
    setValid(validatePhoneNumber(value));
  };

  const validatePhoneNumber = (phoneNumber) => {
    const phoneNumberPattern = /^\+?[1-9]\d{1,14}$/;    
    return phoneNumberPattern.test(phoneNumber);
  };

  ////////////////////////////////

  //  if(startDateRedux < recommendedDate){
  //   setParaText('')
  //  }else if(startDateRedux < recommendedDate || startDateRedux === recommendedDate){
  //   setParaText('')
  //  }

  const dispatch = useDispatch();

  // Here in checkemail function is use to open the 2 inputs---------------

  useEffect(() => {
   
    if (storeSel) {
      console.log("category - branch => ", selectedCategory, selectedBranch);
    }
  }, [storeSel, dispatch]);

  const submitFunc = async (dataparam) => {
    var data = dataparam || myDateState;
    setButtonClicked(true);
    setLoading(true);

    dispatch(
      FormPageAction({
        email: data.email,
        phone: phoneNumber,
      })
    );

    var bodyData = {
      firstname: data.firstname,
      lastname: data.lastname,
      referral_code: data.referral,
      gender: " ",
      birthday: " ",
      country: " ",
      email: data.email,
      contact: phoneNumber,
      location: " ",
      goal: " ",
      billingname: " ",
      gstno: " ",
      panno: " ",
      password: data.password,
      istrial: DataStore.isTrial,
      isverified: 1,
      verifylink: " ",
      changepass: " ",
      openpass: " ",
      block: 0,
    };

    if (showExtraFields) {
      try {
        const response = await axios({
          method: "post",
          url: apiUrl + "/signUp",
          data: bodyData,
          headers: { "Content-Type": "application/json" },
        }).then((response) => {
          if (response.data.status === "success") {
            setApiStatus("success");
            dispatch(
              UseridAction({
                userid: response.data.data.uid,
                firstname: data.firstname,
              })
            );

            // checkEmail(emailNew);

            // dispatch(emailAction(emailNew));
            dispatch(tokenAction(response?.data?.data?.token));
            dispatch(gstnameAction(null));
            dispatch(gstnAction(null));
          }
          setLoading(false);
          // Navigate to the payment page without creating an order
          navigate(
            `/${selectedCategory}/${selectedBranch}/${planNameredux}/confirmation`
          );
        });
      } catch (e) {
        setButtonClicked(false);
        if (e.response.data.errorInfo === "MOBILE_DUPLICATE") {
          setErrorMessagePopup(
            "The phone number already exists, please enter a new one."
          );
          togglePopup();
        } else if (e.response.data.errorInfo === "EMAIL_DUPLICATE") {
          setErrorMessagePopup(
            "The email-id already exists, please enter a new one."
          );
          togglePopup();
        } else if (e.response.data.error) {
          setErrorMessagePopup("Something went wrong, please try again.");
          togglePopup();
        }
      }
    } else {
      // Skip the order creation and navigate to the payment page directly
      setLoading(false);
      setApiStatus("success");
      navigate(
        `/${selectedCategory}/${selectedBranch}/${planNameredux}/confirmation`
      );
    }
  };

  console.log(errors,"errors")

  const onSubmit = (data) => {
    data.referral = data.referral?.toUpperCase();
    console.log(data,"dataform")
    if (!phoneNumber) {
      setError("phone", {
        type: "manual",
        message: "Please enter the phone number",
      });
      return;
    }
    setMyDatastate(data);
    if (recommendedDate !== null) {
      setShowPopupRenewal(true);

      return;
    }

    submitFunc(data);
  };

  let cancelTokenSource;

  const checkEmail = async (email) => {
    // If there's an ongoing API call, cancel it before making a new one
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }

    //  new cancel token source for the current request
    cancelTokenSource = axios.CancelToken.source();

    try {
      dispatch(gstnAction(null));
      dispatch(gstnameAction(null));

      const response = await axios({
        method: "post",
        url: apiUrl + "/checkUserEmail",
        data: {
          email: email,
          typeid: typeId || (appname == 'sweat' ? 4 : 9),
        },
        headers: {
          "Content-Type": "application/json",
        },
        cancelToken: cancelTokenSource.token, // Pass the cancel token to the request
      }).catch((err) => {
        dispatch(emailAction(null));
        setRecommendedDate(null);
        dispatch(rewardsDataAction({rewards_conversion_rate:null,
          rewards_points:null,
          usable_reward_point:null,
          rewards_conversion_amount: null,
          maximum_usable_rewards_coins:null,
          coins_Count:null,
          coins_Value:null,}))
      });

      console.log("Check user email response --> ", response);

      // alert(JSON.stringify(response));

      dispatch(
        UseridAction({
          userid: response.data.data.uid,
          firstname: response.data.data.firstname,
        })
      );

      let local_max_usable_rewards_coins =
        (DataStore["Total Amount"] * response.data.data.usable_reward_point) /
        100 /
        response.data.data.rewards_conversion_rate;

      const usableRewardResult = await calculateUsableReward({
        maxUsableRewardCoins: local_max_usable_rewards_coins,
        totalUserRewardCoins: response.data.data.rewards_points,
        coinConversionRate: response.data.data.rewards_conversion_rate,
      });

      dispatch(
        rewardsDataAction({
          rewards_conversion_rate: response.data.data.rewards_conversion_rate,
          rewards_points: response.data.data.rewards_points,
          usable_reward_point: response.data.data.usable_reward_point,
          rewards_conversion_amount:
            response.data.data.rewards_conversion_rate *
            response.data.data.rewards_points,
          maximum_usable_rewards_coins: local_max_usable_rewards_coins,
          coins_Count: usableRewardResult[0],
          coins_Value: usableRewardResult[1],
        })
      );

      dispatch(gstnAction(response.data.data.gstno));
      dispatch(gstnameAction(response.data.data.billingname));

      /// function calculate usable Reward is in constant file

      setEmailExists(false);
      setShowExtraFields(false);
      if (response.data.recomended_start_date !== null) {
        setRecommendedDate(response?.data?.data?.recomended_start_date);
      }
      // const emailInput = document.getElementById("email-input");
      // emailInput.value = email;
      // if(emailParamsExists) {
      //   emailInput.defaultValue = email;
      //   emailInput.focus();
      // }

      setEmailValue(email);
    } catch (error) {
      if (axios.isCancel(error)) {
        // Handle the canceled request here
        console.log("Request canceled:", error.message);
      } else {
        // Handle other errors
        setEmailExists(true);
        setShowExtraFields(true);
        dispatch(rewardsDataAction({
          rewards_conversion_rate:null,
                          rewards_points:null,
                          usable_reward_point:null,
                          rewards_conversion_amount: null,
                          maximum_usable_rewards_coins:null,
                          coins_Count:null,
                          coins_Value:null,
        }))
        // const emailInput = document.getElementById("email-input");
        // emailInput.value = email;
        // if(emailParamsExists) {
        //   emailInput.defaultValue = email;
        //   emailInput.focus();
        // }
        // ...
      }
    }
  };

  const handleChange = (event) => {
    const email = event.target.value;
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (pattern.test(email)) {
      checkEmail(email);
    }
  };

  //-----------------Password input----------------------------------------
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  useEffect(() => {
    if (emailParam !== undefined && contactParam !== undefined) {
      dispatch(tokenAction(null));
      // checkEmail(emailParam);

      try {
        // const fetchData = async () => {
        //   axios({
        //     method: "post",
        //     url: apiUrl + "/checkUserEmail",
        //     data: {
        //       email: emailParam,
        //       // typeid:typeId
        //     },
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //   })
        //     .then((response) => {
        //       // alert("Check User Email response -> " + JSON.stringify(response));
        //       setEmailValue(emailParam);
        //       if (
        //         response.data &&
        //         response.data.data &&
        //         response.data.data.uid
        //       ) {
        //         dispatch(
        //           UseridAction({
        //             userid: response.data.data.uid,
        //             firstname: response.data.data.firstname,
        //           })
        //         );
        //         dispatch(FormPageContactAction(response.data.data.contact));
        //         dispatch(gstnAction(response.data.data.gstno));
        //         dispatch(gstnameAction(response.data.data.billingname));

        //         let local_max_usable_rewards_coins =
        //         (DataStore["Total Amount"] * response.data.data.usable_reward_point) /
        //         100 /
        //         response.data.data.rewards_conversion_rate;
        
        //         const usableRewardResult = await calculateUsableReward({
        //           maxUsableRewardCoins: local_max_usable_rewards_coins,
        //           totalUserRewardCoins: response.data.data.rewards_points,
        //           coinConversionRate: response.data.data.rewards_conversion_rate,
        //         });
        
        //       dispatch(
        //         rewardsDataAction({
        //           rewards_conversion_rate: response.data.data.rewards_conversion_rate,
        //           rewards_points: response.data.data.rewards_points,
        //           usable_reward_point: response.data.data.usable_reward_point,
        //           rewards_conversion_amount:
        //             response.data.data.rewards_conversion_rate *
        //             response.data.data.rewards_points,
        //           maximum_usable_rewards_coins: local_max_usable_rewards_coins,
        //           coins_Count: usableRewardResult[0],
        //           coins_Value: usableRewardResult[1],
        //         })
        //       );

        //         if (response.data.data.uid) {
        //           window.location.replace(
        //             `${selectedCategory}/${selectedBranch}/${planNameredux}/confirmation`
        //           );
        //         } else {
        //           return;
        //         }
        //       }
        //     })
        //     .catch((error) => {
        //       console.log("error");
        //       // setEmailExists(false);
        //       dispatch(emailAction(null));
        //       // Handle errors
        //     });
        // };
        // fetchData();

        //-------------------------------------2----------------------------------

        const fetchData = async () => {
          try {
              const response = await axios({
                  method: "post",
                  url: apiUrl + "/checkUserEmail",
                  data: {
                      email: emailParam,
                  },
                  headers: {
                      "Content-Type": "application/json",
                  },
              });
      
              // Handle the response
              setEmailValue(emailParam);
              if (response.data && response.data.data && response.data.data.uid) {
                  dispatch(
                      UseridAction({
                          userid: response.data.data.uid,
                          firstname: response.data.data.firstname,
                      })
                  );
                  dispatch(FormPageContactAction(response.data.data.contact));
                  dispatch(gstnAction(response.data.data.gstno));
                  dispatch(gstnameAction(response.data.data.billingname));
      
                  let local_max_usable_rewards_coins =
                      (DataStore["Total Amount"] * response.data.data.usable_reward_point) /
                      100 /
                      response.data.data.rewards_conversion_rate;
      
                  const usableRewardResult = await calculateUsableReward({
                      maxUsableRewardCoins: local_max_usable_rewards_coins,
                      totalUserRewardCoins: response.data.data.rewards_points,
                      coinConversionRate: response.data.data.rewards_conversion_rate,
                  });
      
                  dispatch(
                      rewardsDataAction({
                          rewards_conversion_rate: response.data.data.rewards_conversion_rate,
                          rewards_points: response.data.data.rewards_points,
                          usable_reward_point: response.data.data.usable_reward_point,
                          rewards_conversion_amount:
                              response.data.data.rewards_conversion_rate *
                              response.data.data.rewards_points,
                          maximum_usable_rewards_coins: local_max_usable_rewards_coins,
                          coins_Count: usableRewardResult[0],
                          coins_Value: usableRewardResult[1],
                      })
                  );
      
                  if (response.data.data.uid) {
                      window.location.replace(
                          `${selectedCategory}/${selectedBranch}/${planNameredux}/confirmation`
                      );
                  }
              }
          } catch (error) {
              console.log("error");
              dispatch(emailAction(null));
              setRecommendedDate(null);
              dispatch(rewardsDataAction({
                rewards_conversion_rate:null,
                          rewards_points:null,
                          usable_reward_point:null,
                          rewards_conversion_amount: null,
                          maximum_usable_rewards_coins:null,
                          coins_Count:null,
                          coins_Value:null,
              }))
          }
      };
      
      // Call the fetchData function
      fetchData();
      
      } catch (error) {
        // Handle errors
      }
    }
  }, [emailParam]);

  return (
    <>
      <div className="home-content-container start-content-container">
        <NavText name={DataStore.name} planname={DataStore["Plan Name"]} />
        <Heading headingText="LET'S GET YOU STARTED!" />
        <form className="Start-page-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="form-input">
            <input
              type="text"
              className=""
              name="email"
              id="email-input"
              // defaultValue={}

              {...register("email", {
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                  message: "Invalid email format",
                },
                required: "Please fill out this field",
              })}
              onKeyUp={(e) => {
                handleChange(e);
                setEmailNew(e?.target?.value);
              }}
              defaultValue={emailParamsExists ? emailValue : ""}
              readOnly={emailParamsExists}
              placeholder="Enter email"
            />
            <br />
            {errors.email && <span className="">{errors.email.message}</span>}
          </div>

          {emailExists && showExtraFields && (
            <>
              <div className="form-input">
                <input
                  className=""
                  placeholder="First name"
                  type="text"
                  {...register("firstname", {
                    pattern: {
                      value: /^[a-zA-Z0-9,\s]*$/,
                      message: "Special characters are not allowed",
                    },
                    required: "Please fill out this field",
                  })}
                />
                <br />
                {errors.firstname && (
                  <span className="">{errors.firstname.message}</span>
                )}
              </div>
              <div className="form-input">
                <input
                  className=""
                  placeholder="Last name"
                  type="text"
                  {...register("lastname", {
                    pattern: {
                      value: /^[a-zA-Z0-9,\s]*$/,
                      message: "Special characters are not allowed",
                    },
                    required: "Please fill out this field",
                  })}
                />
                <br />
                {errors.lastname && (
                  <span className="">{errors.lastname.message}</span>
                )}
              </div>

              <div className="form-input">
                <div className="password-div">
                  <input
                    // onChange={}
                    type={showPassword ? "text" : "password"}
                    className=""
                    name="password"
                    {...register("password", {
                      pattern: {
                        value: "",
                        message: "",
                      },
                      required: "Please fill out this field",
                    })}
                    placeholder="Enter Password"
                  />
                  <div
                    className="password-toggle-icon"
                    onClick={toggleShowPassword}
                  >
                    {showPassword ? (
                      <span>
                        <FontAwesomeIcon
                          className="Img-upload-edit-btn"
                          icon={faEye}
                        />
                      </span>
                    ) : (
                      <span>
                        <FontAwesomeIcon
                          className="Img-upload-edit-btn"
                          icon={faEyeSlash}
                        />
                      </span>
                    )}
                  </div>
                </div>
                {/* <br /> */}
                {errors.password && (
                  <span className="">{errors.password.message}</span>
                )}
              </div>

              <div className="form-input">
                <input
                  className=""
                  placeholder="Referral Code"
                  type="text"
                  {...register("referral", {
                    // required: "Please fill out this field",
                  })}
                />
                <br />
                {errors.referral && (
                  <span className="">{errors.referral.message}</span>
                )}
              </div>
            </>
          )}
          <div className="form-input">
            {/* <input
                      // onChange={}
                      type="number"
                      className=""
                      name="number"
                      {...register("number", {
                        pattern: {
                          value: /^[0-9\b]+$/,
                          message: "Invalid contact number format",
                        },
                        required: "Please fill out this field",
                      })}
                      placeholder="Phone"
                    />
                    <br />
                    {errors.number && (
                      <span className="">{errors.number.message}</span>
                    )} */}

            <PhoneInput
              className="phone-number-input"
              country={"in"}
              value={phoneNumber}
              // onChange={handleChangeNumber}
              onChange={(value, country) => handleChangeNumber(value, country)}
              inputProps={{
                required: true,
              }}
            />

            {valid == false && <span className="">Please enter a valid phone number.</span>}
            {errors.phone && <span className="">{errors.phone.message}</span>}
          </div>

          <div className="form-input">
            <p>
              By submitting this form you agree with our{" "}
              <a href={getContentData(appname).termsLink} target="_blank">
                terms & conditions
              </a>{" "}
              and{" "}
              <a
                href={getContentData(appname).privacyPolicyLink}
                target="_blank"
              >
                privacy policy
              </a>
            </p>

            {!buttonClicked ? (
              <button
                // onClick={navigateTo}
                type="submit"
                className="start-submit-input"
              >
                {emailExists ? <>Submit & Register</> : <>Submit</>}
              </button>
            ) : loading || apiStatus !== "success" ? (
              <Player
                autoplay
                loop
                src="asset/Img/spinner.json"
                style={{ width: "50px", height: "50px" }}
              >
                <Controls
                  visible={false}
                  buttons={["play", "repeat", "frame", "debug"]}
                />
              </Player>
            ) : null}
          </div>
        </form>

        {/* <button onClick={togglePopup}>hey hdh</button> */}
      </div>

      {showPopup && (
        <Popup2
          togglePopup2={togglePopup}
          paratext={errorMessagePopup}
          title="Oops!"
        />
      )}

      {showPopupRenewal && (
        <Popup2
          //  selectedDateEnableProp={selectedDateEnable}
          selectedDateRedux={startDateRedux}
          selectedDateEnableProp={
            startDateRedux > recommendedDate ||
            startDateRedux === recommendedDate
              ? false
              : true
          }
          recommendedDate={recommendedDate}
          // selectedDateParam={
          //   startDateRedux < recommendedDate ? recommendedDate : startDateRedux
          // }
          datePicker={true}
          submitFunc={submitFunc}
          togglePopup2={togglePopupRenewal}
          paratext={
            startDateRedux > recommendedDate
              ? `Your active/upcoming plan is expiring before ${moment(
                  startDateRedux
                ).format(
                  "DD MMM YYYY"
                )}, based on that we recommend your start date should be ${moment(
                  recommendedDate
                ).format("DD MMM YYYY")}`
              : startDateRedux < recommendedDate
              ? "You already have an active/upcoming plan with us, based on that we have updated your start date"
              : ""
          }
        />
      )}

      {showPopup2 && (
        <Popup2
          togglePopup2={togglePopup2}
          paratext={
            DataStore.isTrial === 1
              ? "You have already enrolled once for the trial of this plan."
              : "You are already enrolled in this plan. Please note that users cannot purchase a new plan until their current or upcoming plan has expired."
          }
          title="YOU CAN'T PURCHASE THIS PLAN!"
        />
      )}
    </>
  );
};

export default StartContentNew;
